export interface StatusChoice {
  value: string
  label: string
  rank?: number
}

/**
 * What staff set on a project itself: open or cancelled. The words on its pill (Ordering, In transit,
 * Delivered...) come from its POs (USA-1451).
 */
export const PROJECT_STATUS_CHOICES: StatusChoice[] = [
  { value: 'active', label: 'Active' },
  { value: 'cancelled', label: 'Cancelled' },
]

export const ORDER_PART_STATUS_CHOICES: StatusChoice[] = [
  { value: 'pending', label: 'Pending', rank: 10 },
  { value: 'po_processing', label: 'PO Processing', rank: 20 },
  { value: 'ordered', label: 'Ordered', rank: 30 },
  { value: 'shipped', label: 'Shipped', rank: 50 },
  { value: 'in_transit', label: 'In Transit', rank: 60 },
  { value: 'delivered', label: 'Delivered', rank: 80 },
  { value: 'cancelled', label: 'Cancelled' },
]

export const SHIPMENT_STATUS_CHOICES: StatusChoice[] = [
  { value: 'pending', label: 'Pending', rank: 10 },
  { value: 'ready_to_book', label: 'Ready to Book', rank: 35 },
  { value: 'booked', label: 'Booked', rank: 40 },
  { value: 'shipped', label: 'Shipped', rank: 50 },
  { value: 'picked_up', label: 'Picked Up', rank: 60 },
  { value: 'in_transit', label: 'In Transit', rank: 60 },
  { value: 'out_for_delivery', label: 'Out for Delivery', rank: 65 },
  { value: 'delivered', label: 'Delivered', rank: 80 },
  { value: 'cancelled', label: 'Cancelled' },
]

export function shipmentStatusVariant(status: string) {
  if (status === 'delivered') return 'default' as const
  if (status === 'shipped' || status === 'in_transit') return 'secondary' as const
  return 'outline' as const
}

/**
 * PO statuses staff pick, in the words the PO's Order and Shipping pills use (USA-1451). Older and
 * automation-only values (spec credit steps, PO cut, returns...) stay readable on existing POs but are
 * not offered.
 */
export const PO_STATUS_CHOICES: StatusChoice[] = [
  { value: 'generated', label: 'Not sent', rank: 10 },
  { value: 'email_sent', label: 'Sent', rank: 20 },
  { value: 'po_processing', label: 'Confirmed', rank: 20 },
  { value: 'need_to_schedule', label: 'To schedule', rank: 35 },
  { value: 'freight_booked', label: 'Booked', rank: 40 },
  { value: 'in_transit_to_site', label: 'In transit', rank: 60 },
  { value: 'partially_delivered', label: 'Part delivered', rank: 70 },
  { value: 'delivered_to_site', label: 'Delivered', rank: 80 },
  { value: 'cancelled', label: 'Cancelled' },
]
